module.exports = __webpack_public_path__ + "img/mafioso-raids-discord-icon.f3b0c3e7.png";